export default __webpack_public_path__ + "images/3813df672091d478a70dd07a8d1904c1-mountain_background.jpg";